import { render, staticRenderFns } from "./FormAddUser.vue?vue&type=template&id=5080298c"
import script from "./FormAddUser.vue?vue&type=script&lang=js"
export * from "./FormAddUser.vue?vue&type=script&lang=js"
import style0 from "./FormAddUser.vue?vue&type=style&index=0&id=5080298c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports